import React from 'react'
import { ButtonPrimary } from 'components/Common/Buttons'
import useLanguageHooks from 'hooks/useLanguageHooks'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import RollbarConfig from 'utils/RollbarConfig';
import Constant from 'utils/Constants';

export default function ClientError() {
    
  let error = useRouteError();
  const {t} = useLanguageHooks()

  RollbarConfig.error('Error Boundary', {
    'log': error, 
  })

  let message = error + ''
  if(!isRouteErrorResponse(error) && message?.toLocaleLowerCase()?.indexOf('chunkloaderror')>=0) {
    return (
      <div className='luna-client-error-page'>
          <div className='error-body'>
              <img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
              <h2>{t('globalAlert.pageErrorOccuredTitle')}</h2>
              <p>{t('globalAlert.failedLoadChunk')}</p>
  
              <ButtonPrimary onClick={()=>window.location.reload(true) }>{t('common.reload')}</ButtonPrimary>
          </div>
      </div>
    )
  }

  if(error?.status === 404) {
    return (
      <div className='luna-client-error-page'>
          <div className='error-body'>
              <img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
              <h2>{t('globalAlert.notFound')}</h2>
              <p>{t('globalAlert.notFoundMessage')}</p>
  
              <ButtonPrimary onClick={()=>window.location.href = '/'}>{t('common.gotoLogin')}</ButtonPrimary>
          </div>
      </div>
    )
  }

  return (
    <div className='luna-client-error-page'>
        <div className='error-body'>
            <img src={Constant.assets.logo.primary} className="logo" alt='LUNA Logo' />
            <h2>{t('globalAlert.pageErrorOccuredTitle')}</h2>
            <p>{t('globalAlert.pageErrorOccuredMsg')}</p>

            <ButtonPrimary onClick={()=>window.location.href = '/'}>{t('common.gotoLogin')}</ButtonPrimary>
        </div>
    </div>
  )
}
